import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=39962e18"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"
import style0 from "./commodity.vue?vue&type=style&index=0&id=39962e18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports